<script setup lang="ts">
import { createPopper, type Instance as PopperInstance } from '@popperjs/core';
const { horizontalAlignment = 0 } = defineProps<{
    disabled?: boolean;
    horizontalAlignment?: number;
}>();

const opened = ref(false);
const popper = ref<PopperInstance>();
const tooltip = ref<HTMLDivElement>();
const toolTipIcon = ref<HTMLDivElement>();
const { top, left, height } = useElementBounding(toolTipIcon);
const { isOutside } = useMouseInElement(toolTipIcon);
const open = () => {
    if (!isOutside.value) {
        return;
    }
    if (toolTipIcon.value && tooltip.value) {
        popper.value = createPopper(toolTipIcon.value, tooltip.value, {
            placement: 'bottom-start',
            // modifiers: {
            //     flip: { enabled: true },
            // },
        });
    }
};

const close = () => {
    if (!opened.value) {
        return;
    }
    popper.value?.destroy();
};

watchEffect(() => {
    if (tooltip.value?.style && toolTipIcon.value) {
        tooltip.value.style.left = `${left.value - horizontalAlignment}px`;
        tooltip.value.style.top = `${top.value + height.value}px`;
    }
});
</script>

<template>
    <div ref="toolTipIcon" class="tooltip">
        <div @mouseenter="() => open()" @mouseleave="() => close()">
            <slot name="tip" />
        </div>
        <div v-if="!isOutside && !disabled" ref="tooltip" class="detail">
            <slot name="detail" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.tooltip {
    .detail {
        z-index: 999999;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px;
        background-color: usePalette($p-gray, $p-300);
        border-radius: 8px;
        width: fit-content;
    }
}
</style>
